/* eslint-disable react/jsx-no-constructed-context-values */
import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./index.scss";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import routes from "./routes";
import "react-toastify/dist/ReactToastify.css";
import { store } from "./store/store";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

const OVERLAY_BASE_Z_INDEX = 1050;
const OVERLAY_STEP_Z_INDEX = 20;
const OVERLAY_OFFSET_Z_INDEX = 5;
let overlayRestackScheduled = false;

const restackOverlays = () => {
  overlayRestackScheduled = false;

  const overlays = Array.from(
    document.querySelectorAll<HTMLElement>(".modal.show, .offcanvas.show")
  ).sort((leftOverlay, rightOverlay) => {
    const leftPriority = leftOverlay.classList.contains("confirm-dialog-modal")
      ? 1
      : 0;
    const rightPriority = rightOverlay.classList.contains("confirm-dialog-modal")
      ? 1
      : 0;

    return leftPriority - rightPriority;
  });
  const overlayZIndexes = overlays.map((overlay, index) => {
    return (
      OVERLAY_BASE_Z_INDEX +
      index * OVERLAY_STEP_Z_INDEX +
      OVERLAY_OFFSET_Z_INDEX
    );
  });

  overlays.forEach((overlay, index) => {
    overlay.style.zIndex = String(overlayZIndexes[index]);
  });

  Array.from(
    document.querySelectorAll<HTMLElement>(
      ".modal-backdrop.show, .offcanvas-backdrop.show"
    )
  ).forEach((backdrop, index) => {
    const zIndex = OVERLAY_BASE_Z_INDEX + index * OVERLAY_STEP_Z_INDEX;
    backdrop.style.zIndex = String(zIndex);
  });

  Array.from(
    document.querySelectorAll<HTMLElement>(".popover.show, .tooltip.show")
  ).forEach((floatingOverlay) => {
    const parentOverlay = floatingOverlay.closest<HTMLElement>(
      ".modal.show, .offcanvas.show"
    );
    if (parentOverlay) {
      floatingOverlay.style.zIndex = String(
        Number(parentOverlay.style.zIndex || OVERLAY_BASE_Z_INDEX) +
          OVERLAY_OFFSET_Z_INDEX
      );
      return;
    }

    floatingOverlay.style.zIndex = overlayZIndexes.length
      ? String(Math.max(...overlayZIndexes) + OVERLAY_OFFSET_Z_INDEX)
      : "";
  });
};

const scheduleOverlayRestack = () => {
  if (overlayRestackScheduled) {
    return;
  }

  overlayRestackScheduled = true;
  setTimeout(restackOverlays, 0);
};

const overlayObserver = new MutationObserver(scheduleOverlayRestack);
overlayObserver.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ["class"],
});
scheduleOverlayRestack();

(window as any).GM_API_KEY = "AIzaSyB6uCNF8m7C0eL4iZ9caubUtlfU8ZT0mSY";

const { baseUrl: baseURL, isSuperadmin } = JSON.parse(
  (document as any).querySelector("#app").dataset.page
).props;

const router = createBrowserRouter(routes, {
  basename: `${baseURL}/workflows`,
});

export default function Workflows() {
  return (
    <div
      className="App"
      style={{
        height: isSuperadmin ? "calc(100vh - 84px)" : "calc(100vh - 44px)",
      }}
    >
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

/*
React Diagrams
https://github.com/projectstorm/react-diagrams

diagram engine settings in Diagrams.jsx file



*/
